// extracted by mini-css-extract-plugin
module.exports = {"styledIcon":"SDJsKF7T","enableHover":"dSuTXQkU","isDisabled":"eisudsBr"};